import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../root.model'
import { CommentaryCountsRedux } from './commentary-counts.reducer'

const selectSlice = (state: RootState): CommentaryCountsRedux =>
  state.helios.commentaryCounts

/** Within-account entity counts keyed by accountId. */
export const selectCommentaryCountsByAccount = createSelector(
  selectSlice,
  s => s.countsByAccount,
)

/** DLITE-4112: per-account total thread counts for the account-list grids. */
export const selectCommentaryAccountCounts = createSelector(
  selectSlice,
  s => s.accountCounts,
)

export const selectCommentaryCountsError = createSelector(
  selectSlice,
  s => s.error,
)

const NO_UNAVAILABLE: Record<string, true> = {}

/** DLITE-5094: accounts whose commentary the user cannot read. */
export const selectCommentaryUnavailableAccountIds = createSelector(
  selectSlice,
  s => s.unavailableAccountIds ?? NO_UNAVAILABLE,
)
